import { Window, Cordova } from '@/types/cordova'
import { Platform } from '@/constants/app'

export const setCordova = (cordova: { platformId: Platform }) => {
  const w = window as Window
  w.cordova = cordova as Cordova
}
